/**
 * Winter Editions 2026 – base theme JS
 */
(function () {
  'use strict';

  // Skip link focus
  document.querySelector('.skip-link')?.addEventListener('click', function (e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: false });
    }
  });

  // Donation amount selection
  document.querySelectorAll('.donation-amounts').forEach(function (block) {
    block.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        block.querySelectorAll('label').forEach(function (l) { l.classList.remove('selected'); });
        var checked = block.querySelector('input[name="' + radio.name + '"]:checked');
        if (checked && checked.nextElementSibling) {
          checked.nextElementSibling.classList.add('selected');
        }
      });
    });
  });

  // Optional: lazy-load images
  if ('IntersectionObserver' in window) {
    var imgObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset && img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          imgObserver.unobserve(img);
        }
      });
    }, { rootMargin: '50px' });

    document
      .querySelectorAll('.art-card__image img[data-src], .product-card__image img[data-src]')
      .forEach(function (img) { imgObserver.observe(img); });
  }

  // ------------------------------
// Subscription text overrides (SAFE)
// ------------------------------
function replaceSubscriptionText(root) {
  var scope = root || document;

  scope.querySelectorAll('.shopify_subscriptions_app_block_label label').forEach(function (label) {
    label.childNodes.forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent) {
        var before = node.textContent;
        var after = before;

        // bezorg-woorden vervangen
        after = after.replace(/\bbezorgen\b/gi, 'doneren');

        // Eenmalige aankoop → Eenmalige donatie
        after = after.replace(/Eenmalige aankoop/gi, 'Eenmalige donatie');

        // Alleen schrijven als het écht verandert (scheelt events/perf)
        if (after !== before) node.textContent = after;
      }
    });
  });
}

function initSubscriptionTextFix() {
  // 1) Run once
  replaceSubscriptionText(document);

  // 2) Observe ONLY DOM additions (geen characterData!)
  var container =
    document.querySelector('.shopify_subscriptions_app_block_label') ||
    document.querySelector('[data-shopify-subscriptions]');

  // Als we de container niet vinden, stop dan netjes (geen body observer)
  if (!container) return;

  var scheduled = false;
  function scheduleReplace() {
    if (scheduled) return;
    scheduled = true;
    // throttle naar 1x per frame
    requestAnimationFrame(function () {
      scheduled = false;
      replaceSubscriptionText(container);
    });
  }

  var obs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
        scheduleReplace();
        break;
      }
    }
  });

  obs.observe(container, { childList: true, subtree: true });

  // 3) Extra: bij change events (radio’s) één keer opnieuw toepassen
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;

    if (t.matches('input[data-radio-type="selling_plan"], input[data-radio-type="selling_plan_group"]')) {
      scheduleReplace();
    }
  });
}

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSubscriptionTextFix);
} else {
  initSubscriptionTextFix();
}

})();